import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'play-off',
  size: 24,
  node: [
    ['path', { d: 'm10.215 4.56 9.79 5.71a2 2 0 0 1 .003 3.458l-.393.23', key: 'fdtkwz' }],
    ['path', { d: 'm16.042 16.042-8.034 4.686A2 2 0 0 1 5 19V5', key: '1c8hxg' }],
    ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name PlayOff
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAuMjE1IDQuNTYgOS43OSA1LjcxYTIgMiAwIDAgMSAuMDAzIDMuNDU4bC0uMzkzLjIzIiAvPgogIDxwYXRoIGQ9Im0xNi4wNDIgMTYuMDQyLTguMDM0IDQuNjg2QTIgMiAwIDAgMSA1IDE5VjUiIC8+CiAgPHBhdGggZD0ibTIgMiAyMCAyMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/play-off
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlayOff = createLucideIcon(__iconData);

export default PlayOff;
